import { t } from '~/helpers/localization';

import styles from '~/UIKit/ClansRating/ClansRating.scss';
import LadderSeasonsDropdown from '~/UIKit/LadderSeasonsDropdown/LadderSeasonsDropdown';
import RealmDropdown from '~/UIKit/RealmDropdown/RealmDropdown';

import type { SEASON_TYPES } from '~/constants';

interface SeasonsMenuProps {
  clanBattleRealm?: string;
  clanHomeRealm?: string;
  currentRealm: string;
  currentSeason?: number;
  currentSeasonType?: SEASON_TYPES;
  isBrawl: boolean;
  onRealmChange: (realm: string) => void;
  onSeasonChange: (season: number, seasonType?: SEASON_TYPES) => void;
}

const SeasonsMenu = ({
  clanBattleRealm,
  clanHomeRealm,
  currentRealm,
  currentSeason,
  currentSeasonType,
  onRealmChange,
  onSeasonChange,
}: SeasonsMenuProps) => {
  const currentSeasonId = parseInt(`${currentSeason}`, 10);

  return (
    <div className={styles.season}>
      <div className={styles.clanRegularBadge}>
        <span>{t('Клановые бои')}</span>
      </div>
      <LadderSeasonsDropdown
        selectedSeasonId={currentSeasonId}
        selectedSeasonType={currentSeasonType}
        onSeasonChange={onSeasonChange}
      />
      <RealmDropdown
        currentSeasonId={currentSeasonId}
        clanHomeRealm={clanHomeRealm}
        clanBattleRealm={clanBattleRealm}
        itemSelected={currentRealm}
        onRealmChange={onRealmChange}
        isBrawl={false}
      />
    </div>
  );
};

export default SeasonsMenu;
